import React from 'react'

interface GooglePayIconProps {
  width?: number
  height?: number
  className?: string
}

const GooglePayIcon: React.FC<GooglePayIconProps> = ({
  width = 35,
  height = 24,
  className = ''
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="34"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D9D9D9"
      />
      <g transform="translate(5, 7)">
        <path
          d="M22.4976 7.31855H22.5151L23.9741 3.65546H25.0005L21.8462 11.0002H20.8735L22.0454 8.43085L19.9771 3.65546H21.0024L22.4976 7.31855ZM17.562 3.48945C18.2592 3.4895 18.81 3.67951 19.2144 4.0539C19.6188 4.42855 19.8188 4.9524 19.8188 5.61249V8.758H18.9155V8.04999H18.8745C18.4819 8.63266 17.9664 8.92488 17.3159 8.92499C16.7649 8.92499 16.2955 8.75801 15.9263 8.42499C15.5629 8.11576 15.3579 7.65762 15.3696 7.17597C15.3697 6.64686 15.5688 6.23035 15.9614 5.91523C16.3541 5.60011 16.8821 5.4455 17.5386 5.4455C18.1011 5.44554 18.5581 5.55297 18.9214 5.75507V5.53535C18.9214 5.2083 18.7808 4.89884 18.5347 4.68476C18.2827 4.45885 17.9605 4.33424 17.6265 4.33417C17.0989 4.33417 16.6822 4.55996 16.3774 5.01191L15.5454 4.48261C15.9909 3.82252 16.6652 3.48945 17.562 3.48945ZM13.0894 1.30097C13.6931 1.28909 14.2796 1.52125 14.7075 1.94941C15.5628 2.75808 15.6155 4.1193 14.813 4.99335L14.7075 5.10078C14.2679 5.52299 13.7282 5.73749 13.0894 5.73749H11.5298V8.758H10.5864V1.30097H13.0894ZM17.6851 6.21894C17.3042 6.21895 16.982 6.31405 16.7241 6.49824C16.472 6.68259 16.3423 6.91503 16.3423 7.19453C16.3424 7.44412 16.4605 7.67591 16.6538 7.81855C16.8648 7.9849 17.1225 8.07449 17.3862 8.06855C17.7849 8.06853 18.1664 7.90769 18.4478 7.62226C18.7583 7.32497 18.9165 6.9738 18.9165 6.56953C18.6234 6.33166 18.2127 6.21299 17.6851 6.21894ZM11.5298 4.82148H13.1128C13.4645 4.83337 13.805 4.69047 14.0454 4.43476C14.5378 3.91738 14.5261 3.08464 14.0161 2.58515C13.7758 2.3473 13.4528 2.21699 13.1128 2.21699H11.5298V4.82148Z"
          fill="#3C4043"
        />
        <path
          d="M8.27202 5.08295C8.27202 4.79156 8.24857 4.50017 8.20168 4.21472H4.22168V5.86197H6.50183C6.40804 6.39124 6.10324 6.86698 5.65776 7.16431V8.23473H7.01764C7.81481 7.49139 8.27202 6.39124 8.27202 5.08295Z"
          fill="#4285F4"
        />
        <path
          d="M4.22186 9.26949C5.359 9.26949 6.3203 8.88889 7.01783 8.23475L5.65794 7.16433C5.27694 7.42599 4.79043 7.57466 4.22186 7.57466C3.11989 7.57466 2.1879 6.81942 1.85379 5.80847H0.452881V6.91457C1.16799 8.35963 2.62752 9.26949 4.22186 9.26949Z"
          fill="#34A853"
        />
        <path
          d="M1.85401 5.80847C1.67814 5.27921 1.67814 4.70238 1.85401 4.16717V3.06702H0.452877C-0.150959 4.27421 -0.150959 5.70143 0.452877 6.90862L1.85401 5.80847Z"
          fill="#FBBC04"
        />
        <path
          d="M4.22186 2.40099C4.8256 2.38909 5.4059 2.62102 5.83965 3.04324L7.04713 1.81821C6.27927 1.0927 5.27108 0.694267 4.22186 0.706161C2.62752 0.706161 1.16799 1.62196 0.452881 3.06703L1.85379 4.17312C2.1879 3.15623 3.11989 2.40099 4.22186 2.40099Z"
          fill="#EA4335"
        />
      </g>
    </svg>
  )
}

export default GooglePayIcon
